export { UserAvatar } from './UserAvatar';
export { IUserAvatarProps } from './UserAvatar.types';
export { withSizeL } from './_size/UserAvatar_size_l';
export { withSizeM } from './_size/UserAvatar_size_m';
export { withSizeS } from './_size/UserAvatar_size_s';
